import styled from 'styled-components';
import { media, zIndex } from 'utils';

export const ContainerWrapper = styled.div`
  position: absolute;
  width: 100%;
  transform: translateY(100vh);
  z-index: ${zIndex.level2};

  background: linear-gradient(180deg, rgba(19, 19, 19, 1) 0%, rgba(0, 0, 0, 1) 44%);
`;

export const VideoWrapper = styled.div`
  ${media.tabletViewportWidth`
    display: flex;
    justify-content: space-around;
  `}
`;

export const PhotoWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  margin: 0 auto;

  ${media.tabletViewportWidth`
    width: 90%;
  `}
`;

export const ComponentWrapper = styled.section`
  padding: ${({ large }) => (large ? '4rem 0' : '2rem 0')};
  background: transparent;
  position: relative;
  z-index: ${zIndex.level10};
  color: #fff;

  ${media.tabletViewportWidth`
    width: 100%;
    max-width: 779.80px;
  `}
`;

export const TextWrapper = styled.div`
  text-align: ${({ center }) => (center ? 'center' : 'left')};
  font-family: GothamLight;
  font-size: 15px;
  letter-spacing: 0.6px;
  font-weight: 700;
  line-height: 20px;

  h2 {
    font-size: 15px;
    letter-spacing: 0.6px;
    font-weight: 700;
    display: inline-block;
    margin-bottom: 0;
  }

  ${media.tabletViewportWidth`
    width: 692px;
    margin: 0 auto;
  `}

  ${media.tabletLandscapeViewportWidth`
  width: 779.80px;
    margin: 0 auto;
  `}
`;
